// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qEWo","top":"styles_top__3H1KH"};